export default __webpack_public_path__ + "static/picHackaviz-7e8688ef8f197d6da61d70c8c0cf774e.jpg";